import React from 'react';
import InputSection from './InputSection';
import OutputSection from './OutputSection';

const Home = ({
    message,
    setMessage,
    selectedTone,
    setSelectedTone,
    onRewrite,
    rewrittenMessage,
    onCopy,
    copySuccess,
    isProcessing
}) => {
    return (
        <>

            {/* Hero Section */}
            {/* <div className="my-4 sm:mb-6 lg:mb-8">
                <div className="rounded-xl p-6 sm:p-8 lg:p-10 bg-gradient-to-br from-primary-600 to-primary-700 dark:from-primary-700 dark:to-primary-800 text-white shadow-lg shadow-primary-500/20">
                    <div className="max-w-4xl">
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
                            Transform Your Writing Instantly
                        </h1>
                        <p className="text-lg sm:text-xl text-white/90 dark:text-white/80 mt-4 leading-relaxed">
                            Ensure your writing is mistake-free and polished. Transform casual messages into professional communication in seconds.
                        </p>
                        <div className="mt-6 flex flex-wrap gap-3 text-sm sm:text-base">
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                <span>Grammar & Spell Check</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                <span>Multiple Tones</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                <span>Instant Results</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* Main Editor Grid */}
            <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 min-h-0">
                <InputSection
                    message={message}
                    setMessage={setMessage}
                    selectedTone={selectedTone}
                    setSelectedTone={setSelectedTone}
                    onRewrite={onRewrite}
                    isProcessing={isProcessing}
                />

                <OutputSection
                    rewrittenMessage={rewrittenMessage}
                    onCopy={onCopy}
                    copySuccess={copySuccess}
                    isProcessing={isProcessing}
                />
            </div>


        </>
    );
};

export default Home;

